export const widgets = {
  hiringEngineers: {
    title: 'Hiring engineers?',
    description:
      'We provide nearshore tech talent to companies from startups to enterprises like Google and Rolls-Royce.',
    talents: [
      {
        name: 'Fiorella G.',
        role: 'Sr. Data Scientist',
        image: {
          url: 'https://assets.bairesdev.com/image/upload/www/static/talent-3_efq9gh',
          alt: 'Fiorella G.',
        },
        // Served from apps/blog/public; prefix NEXT_PUBLIC_BASE_PATH when rendering
        countryFlag: { src: '/flags/brazil.svg', alt: 'Brazil' },
      },
      {
        name: 'Alejandro D.',
        role: 'Sr. Full-stack Dev.',
        image: {
          url: 'https://assets.bairesdev.com/image/upload/www/static/talent-1_ylgyum',
          alt: 'Alejandro D.',
        },
        countryFlag: { src: '/flags/colombia.svg', alt: 'Colombia' },
      },
      {
        name: 'Gustavo A.',
        role: 'Sr. QA Engineer',
        image: {
          url: 'https://assets.bairesdev.com/image/upload/www/static/talent-2_aapbp9',
          alt: 'Gustavo A.',
        },
        countryFlag: { src: '/flags/argentina.svg', alt: 'Argentina' },
      },
    ],
    links: [
      {
        label: 'About Us',
        href: 'https://www.bairesdev.com/about/',
      },
      {
        label: 'Our Services',
        href: 'https://www.bairesdev.com/software-development-services/',
      },
      {
        label: 'Our Clients',
        href: 'https://www.bairesdev.com/clients/',
      },
    ],
  },
};

export default widgets;
